import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryHandler: ErrorHandler;

  constructor() {
    this.sentryHandler = Sentry.createErrorHandler({
      showDialog: true,
    });
  }

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const dynamicImportMessage = /Failed to fetch dynamically imported module/;
    const failedToFetchMessage = /Failed to fetch/;

    if (error && (chunkFailedMessage.test(error.message) || dynamicImportMessage.test(error.message))) {
      console.error('Chunk load error detected, reloading...', error);
      // Prevent infinite reload loops if the error persists
      const lastReload = localStorage.getItem('last_chunk_error_reload');
      const now = Date.now();

      if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
        localStorage.setItem('last_chunk_error_reload', now.toString());
        window.location.reload();
      } else {
        // If we reloaded recently and it still fails, let Sentry handle it
        this.sentryHandler.handleError(error);
      }
    } else if (error && failedToFetchMessage.test(error.message)) {
      // Ignore "Failed to fetch" errors as they are usually network issues
      // and are already handled by the error notification interceptor (status 0)
      // We don't want to spam Sentry with these.
      console.warn('Network error detected (Failed to fetch), suppressed from Sentry:', error);
    } else {
      this.sentryHandler.handleError(error);
    }
  }
}
